import {
  COMENZAR_LOGIN,
  EVENTO_LOGIN_EXITO,
  EVENTO_LOGIN_ERROR,
  EVENTO_LOGOUT_EXITO,
  EVENTO_LOGOUT_ERROR,
  COMENZAR_RECORDAR_CONTRASENA,
  EVENTO_RECORDAR_CONTRASENA_ERROR,
  EVENTO_RECORDAR_CONTRASENA_EXITO,
  RESET_ERROR_LOGIN
} from "../types";

import { getCookie } from "../../utils/cookieUtils";

const userCookie = getCookie("user");
const user = userCookie ? { usuario: JSON.parse(userCookie) } : null;

const initialState = user
  ? {
      autenticado: true,
      user,
      error: false,
      errorMessage: null,
      loading: false,
    }
  : {
      autenticado: false,
      user: null,
      error: false,
      errorMessage: null,
      loading: false,
    };

function loginReducer(state = initialState, action) {
  switch (action.type) {
    case RESET_ERROR_LOGIN:
      return {
        ...state,
        error: false,
        errorMessage: null,
      };
    case COMENZAR_RECORDAR_CONTRASENA:
    case COMENZAR_LOGIN:
      return {
        ...state,
        loading: true,
        autenticado: false,
        user: null,
        error: false,
        errorMessage: null,
      };
    case EVENTO_LOGIN_EXITO:
      return {
        ...state,
        loading: false,
        autenticado: true,
        user: action.payload,
      };
    case EVENTO_RECORDAR_CONTRASENA_ERROR:
    case EVENTO_LOGIN_ERROR:
    case EVENTO_LOGOUT_ERROR:
      return {
        ...state,
        loading: false,
        autenticado: false,
        user: null,
        error: action.payload.error,
        errorMessage: action.payload.message,
      };
    case EVENTO_RECORDAR_CONTRASENA_EXITO:
    case EVENTO_LOGOUT_EXITO:
      return {
        ...state,
        loading: false,
        autenticado: false,
        user: null,
        error: null,
      };
    default:
      return state;
  }
}

export default loginReducer;
